import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import moment from "moment";
import { formatMessage } from "devextreme/localization";
import { useScreenSize } from "../../../utils/media-query";

import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import { useAuth } from "../../../contexts/auth";
import { axios } from "../../../common";

export default function OvertimeRegistrationDataTableList({
  dataGrid,
  middleware,
}) {
  const { user } = useAuth();
  const [status, setStatus] = React.useState();
  const [fromDate, setFromDate] = React.useState();
  const [toDate, setToDate] = React.useState();
  const { isXSmall, isSmall } = useScreenSize();
  const [overtime, setOvertime] = React.useState([]);

  const handleChangeSelectBox = async () => {
    const FromDate = moment(fromDate).format("YYYY-MM-DD");
    const ToDate = moment(toDate).format("YYYY-MM-DD");

    const payload = {
      Status: status,
      FromDate: FromDate,
      ToDate: ToDate,
      EmployeeOid: user?.EmployeeOid,
    };
    const { data } = await axios.get("OvertimeRegistrationData", {
      params: {
        $expand: "Employee,Shift",
        $filter:
          "Employee/Oid eq " +
          user?.EmployeeOid +
          "" +
          " and OvertimeDate gt " +
          payload.FromDate +
          "" +
          " and OvertimeDate lt " +
          payload.ToDate +
          "" +
          " and RequestStatus in [" +
          payload.Status.map((status) => `'${status}'`) +
          "]",
      },
    });
    if (!data) {
      return;
    }
    setOvertime(data.value);
  };
  return (
    <DataGrid
      id="gridContainer"
      height={document.documentElement.offsetHeight - 189}
      showBorders={true}
      showRowLines={true}
      hoverStateEnabled={true}
      rowAlternationEnabled={true}
      columnAutoWidth={true}
      columnResizingMode="widget"
      alignment="center"
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnHidingEnabled={true}
      ref={(e) => {
        dataGrid.current = e;
      }}
      dataSource={overtime}
    >
      {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder="Search..."
      /> */}

      <Selection
        mode="multiple"
        selectAllMode="page"
        showCheckBoxesMode="always"
      />
      <FilterRow visible={true} />
      <Paging defaultPageSize={10} />
      <Pager
        showPageSizeSelector={true}
        allowedPageSizes={[10, 20, 50, 100]}
        showInfo={true}
        visible={true}
      />
      <Column
        caption={formatMessage("EmployeeCode")}
        dataField="Employee.EmployeeCode"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 1 : false}
      />
      <Column
        caption={formatMessage("FullName")}
        dataField="Employee.FullName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("ShiftName")}
        dataField="Shift.Name"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("IsWorkingShift")}
        dataField="IsWorkingShift"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("IsContinueShiftTimeOut")}
        dataField="IsContinueShiftTimeOut"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("IsOverNight")}
        dataField="IsOverNight"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("OvertimeDate")}
        dataField="OvertimeDate"
        dataType="date"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("TimeIn")}
        dataField="TimeIn"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("TimeOut")}
        dataField="TimeOut"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("Remarks")}
        dataField="Remarks"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("TotalHours")}
        dataField="TotalHours"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("ProductionNumber")}
        dataField="ProductionNumber"
        dataType="number"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("Reason")}
        dataField="Reason"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("Description")}
        dataField="Description"
        dataType="string"
      />
      <Column
        caption={formatMessage("RequestStatus")}
        dataField="RequestStatus"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("PrevApprovalName")}
        dataField="PrevApprovalName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("PrevApprovedDate")}
        dataField="PrevApprovedDate"
        dataType="date"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("PrevApprovalStatus")}
        dataField="PrevApprovalStatus"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("PrevApprovalComments")}
        dataField="PrevApprovalComments"
        dataType="string"
      />
      <Column
        caption={formatMessage("CurrentApprovalName")}
        dataField="CurrentApprovalName"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("CancelReason")}
        dataField="CancelReason"
        dataType="string"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Column
        caption={formatMessage("CanceledDate")}
        dataField="CanceledDate"
        dataType="date"
        hidingPriority={isXSmall || isSmall ? 7 : false}
      />
      <Toolbar className="datagrid-toolbar-actions">
        <Item
          location="before"
          locateInMenu={isXSmall || isSmall ? "always" : "auto"}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          <ToolbarBefore
            middleware={middleware}
            setFromDate={setFromDate}
            setToDate={setToDate}
            dataGrid={dataGrid}
            setStatus={setStatus}
            handleChangeSelectBox={handleChangeSelectBox}
          />
        </Item>
        <Item
          location="after"
          locateInMenu={isXSmall || isSmall ? "always" : "auto"}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          <ToolbarAfter middleware={middleware} dataGrid={dataGrid} />
        </Item>
      </Toolbar>
    </DataGrid>
  );
}
